module.exports = __webpack_public_path__ + "img/002_google_au.6337304a.png";